import {
    FIN_PARAMLOAD_PARAM,
    CHANGE_ENV_PARAM,
    CHANGE_REGION_PARAM
} from './actions';

const initData = {
    //★ここから公開版で削除
    //    env: {
    //        river: {
    //            0: {name: '石狩川', path: ['W05-09_0'], pref: '北海道'},
    //            1: {name: '豊平川', path: ['W05-09_0'], pref: '北海道'},
    //            32: {name: '厚別川', path: ['W05-09_0'], pref: '北海道'},
    //            33: {name: '月寒川', path: ['W05-09_0'], pref: '北海道'},
    //            34: {name: 'ラウネナイ川', path: ['W05-09_0'], pref: '北海道'},
    //            35: {name: '望月寒川', path: ['W05-09_0'], pref: '北海道'},
    //            59: {name: '多摩川', path: ['W05-09_1'], pref: '東京'},
    //            60: {name: '秋川', path: ['W05-09_1'], pref: '東京'},
    //            88: {name: '木曽川', path: ['W05-09_2'], pref: '愛知'},
    //            39: {name: '淀川', path: ['W05-09_2'], pref: '大阪'},
    //            40: {name: '神崎川', path: ['W05-09_2'], pref: '大阪'}
    //        },
    //        lake: {
    //            0: {name: '湖1', path: ['lake'], pref: '北海道'},
    //            1: {name: '湖2', path: ['lake'], pref: '大阪'}
    //        },
    //        sea: {
    //            79: {name: '北海道海岸', path: ['C23-06_0'], pref: '北海道'},
    //            89: {name: '伊古部海岸', path: ['W05-09_2'], pref: '愛知'},
    //            80: {name: '大阪湾', path: ['C23-06_0'], pref: '大阪'},
    //            81: {name: '兵庫海岸', path: ['C23-06_0'], pref: '兵庫'}
    //        },
    //        volcano: {
    //            86: {name: '支笏湖', path: ['volcano'], pref: '北海道'},
    //            87: {name: '二上山', path: ['volcano'], pref: '大阪'}
    //        }
    //    },
    //★ここまで公開版で削除
    region: {
        1: {
            name: '札幌',
            range: { x1: 141.27195555, x2: 141.46202222, y1: 42.99063333, y2: 43.09049444 },
            zoom: 22,
            //★ここから公開版で削除
            //            env: {river: [0, 1, 32, 33, 34, 35], sea: [79], volcano: [86]},
            //            ds: [
            //                {//ここにもrangeが入ってくる予定
            //                    ID: 1,
            //                    name: '札幌東西1-6南北3-6_idojibiki-kunijiban-gakkai-sakuseikyokai',
            //                    env: {river: [0, 1, 32, 33, 34, 35], sea: [79], volcano: [86]}, //選択した環境ID
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //                },
            //                {
            //                    ID: 2,
            //                    name: '札幌東西1-6南北3-6_gakkai抜き',
            //                    env: {river: [33, 34, 35], sea: [79], volcano: [86]},
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //                },
            //                {
            //                    ID: 3,
            //                    name: '札幌東西1-6南北3-6_環境抜き_idojibiki-kunijiban-sakuseikyokai-gakkai',
            //                    env: {river: [33, 34, 35], volcano: [86]},
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //               }
            //            ]
            //★ここまで公開版で削除
        },
        //★ここから公開版で削除
        2: {
            name: '北海道',
            range: { x1: 139.4, x2: 145.9, y1: 41.39, y2: 45.6 },
            zoom: 19,
            //            env: {river: [33, 34, 35], sea: [79], volcano: [86]},
            //            ds: [
            //                {
            //                    ID: 1,
            //                    name: '石狩平野',
            //                    env: {river: [34, 35], sea: [79], volcano: [86]},
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //                }
            //            ]
        },
        //★ここまで公開版で削除
        3: {
            name: '東京近郊',
            //range: {x1: 138.905, x2: 139.96, y1: 35.49, y2: 35.92},
            range: { x1: 138.69, x2: 140.85, y1: 34.9, y2: 36.33 },
            zoom: 19,
            //★ここから公開版で削除
            //            env: {river: [59, 60], sea: [], volcano: []},
            //            ds: [
            //                {
            //                    ID: 1,
            //                    name: '東京',
            //                    env: {river: [59, 60]},
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //                }
            //            ]
            //★ここまで公開版で削除
        },
        //★ここから公開版で削除
        //        4: {
        //            name: '愛知',
        //            range: {x1: 136.6708333, x2: 137.8380556, y1: 34.57805556, y2: 35.425},
        //            zoom: 10,
        //            env: {river: [88], sea: [89], volcano: []},
        //            ds: [
        //                {
        //                    ID: 6,
        //                    name: '愛知',
        //                    env: {river: [88]},
        //                    alg: 'randomforest',
        //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
        //                    fs: [0.1, 0.5, 0.9],
        //                    dz: 1.0,
        //                    nz: 50.0
        //                }
        //            ]
        //        },
        //★ここまで公開版で削除

        4: {
            name: '大阪',
            range: { x1: 135.06, x2: 135.77, y1: 34.242, y2: 35.09 },
            zoom: 19,
            //★ここから公開版で削除
            //            env: {river: [39, 40], sea: [80, 81], volcano: [87]},
            //            ds: [
            //                {
            //                    ID: 7,
            //                    name: '大阪',
            //                    env: {river: [39], sea: [80], volcano: [87]},
            //                    alg: 'randomforest',
            //                    algParam: {n_estimators: 100, max_depth: null, n_jobs: -1, random_state: 42},
            //                    fs: [0.1, 0.5, 0.9],
            //                    dz: 1.0,
            //                    nz: 50.0
            //                }
            //            ]
            //★ここまで公開版で削除
        },

        5: {
            name: '愛知',
            range: { x1: 136.55, x2: 137.85, y1: 34.56, y2: 35.5 },
            zoom: 19,

        },
        6: {
            name: '福岡',
            range: { x1: 129.8, x2: 131.6, y1: 32.5, y2: 34.07 },
            zoom: 19,
        },
        7: {
            name: '宮城',
            range: { x1: 140.21, x2: 141.78, y1: 37.74, y2: 39.05 },
            zoom: 19,
        },
        8: {
            name: '中国・四国',
            range: { x1: 131.8, x2: 134.0, y1: 34.1, y2: 35.62 },
            zoom: 19,
        },

    },
    finParamLoad: false
};

export function paramReducer(state = initData, action) {
    switch (action.type) {
        case FIN_PARAMLOAD_PARAM:
            return finParamLoadReduce(state, action);
        case CHANGE_ENV_PARAM:
            return changeEnvReduce(state, action);
        case CHANGE_REGION_PARAM:
            return changeRegionReduce(state, action);
        default:
            return state;
    }
}

export function finParamLoadReduce(state, action) {
    return {
        ...state,
        finParamLoad: action.isFin
    };
}

export function changeEnvReduce(state, action) {
    return {
        ...state,
        env: action.data
    };
}

export function changeRegionReduce(state, action) {
    return {
        ...state,
        region: action.data
    };
}
